"use client"

import type { Event } from "openapi/api/model"
import { Badge } from "@/components/ui/badge"
import { JoinMeetingLink } from "@/components/calendar/join-meeting-link"
import { resolveEventChatbotJoinPayload } from "@/hooks/use-event-chatbot-join"

type EventMeetingMetadataProps = {
  event: Event
  showAttendeeList?: boolean
}

export function EventMeetingMetadata({ event, showAttendeeList = false }: EventMeetingMetadataProps) {
  const metadata = event.provider_meeting_metadata ?? null
  const meetingUrl = metadata?.meeting_url ?? metadata?.web_link ?? event.meeting_url
  const provider = metadata?.provider
  const timeZone = metadata?.time_zone
  const attendeeEmails =
    event.invitee_emails
    ?? metadata?.attendees
      ?.map((attendee) => attendee.email?.trim())
      .filter((email): email is string => Boolean(email))
    ?? []

  if (!metadata && !meetingUrl) return null

  let chatbotJoinPayload = null

  try {
    chatbotJoinPayload = resolveEventChatbotJoinPayload({ event })
  } catch {
    chatbotJoinPayload = null
  }

  return (
    <div className="space-y-1">
      {meetingUrl && (
        <JoinMeetingLink meetingUrl={meetingUrl} payload={chatbotJoinPayload} />
      )}
      {metadata && (
        <div className="flex flex-wrap gap-2 text-xs text-muted-foreground">
          {provider && <span>Provider: {provider}</span>}
          {timeZone && <span>TZ: {timeZone}</span>}
        </div>
      )}

      {showAttendeeList && attendeeEmails.length > 0 && (
        <div className="space-y-1">
          <p className="text-xs font-medium text-muted-foreground">Attendees:</p>
          <div className="flex flex-wrap gap-1.5">
            {attendeeEmails.map((email) => (
              <Badge key={email} variant="secondary" className="text-[10px]">
                {email}
              </Badge>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
